import { combineReducers } from 'redux';

import { NewsPostDetailReducerState, newsPostDetailReducer } from '../news-post-detail/store/news-post-detail-reducer';
import { NewsPostListReducerState, newsPostListReducer } from '../news-post-list/store/news-post-list-reducer';

export interface NewsPostReducerState {
    newsPostList: NewsPostListReducerState;
    newsPostDetail: NewsPostDetailReducerState;
}

export const newsPostReducer = combineReducers<NewsPostReducerState>({
    newsPostList: newsPostListReducer,
    newsPostDetail: newsPostDetailReducer,
});
